import { Masonry } from "masonry-layout";
import { MpBookmark } from "../../common/bookmark.js";

function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	for (const bookmark of document.querySelectorAll("._gamecard_bookmark")) {
		if (bookmark.dataset.ct && bookmark.dataset.id) {
			fetch(`/misc/bookmark/${bookmark.dataset.ct}/${bookmark.dataset.id}/`, {
				headers: {
					"X-Requested-With": "XMLHttpRequest",
				},
				cache: "no-cache",
			})
				.then((response) => response.json())
				.then((data) => {
					const template = data.template;
					const dom_element_id = data.dom_element_id;
					if (template && dom_element_id) {
						document.querySelector(`#${dom_element_id}`).innerHTML = template;
						init_gamecard_bookmark(dom_element_id);
					}
				})
				.catch((error) => {
					console.warn(error);
				});
		}
	}
});

// Bookmarks
function init_gamecard_bookmark(dom_element_id) {
	const game_follow = new MpBookmark(
		document.querySelector(`#${dom_element_id}`),
		{
			message: document.querySelector(`#${dom_element_id} .tab_label`),
			message_on: "Non seguire",
			message_off: "Segui",
			form: document.querySelector(`#${dom_element_id} .bookmarks_form`),
		},
	);
}
